import { render, staticRenderFns } from "./EditClient.vue?vue&type=template&id=00aba756&scoped=true&"
import script from "./EditClient.vue?vue&type=script&lang=ts&"
export * from "./EditClient.vue?vue&type=script&lang=ts&"
import style0 from "./EditClient.vue?vue&type=style&index=0&id=00aba756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aba756",
  null
  
)

export default component.exports